import { Injectable } from '@angular/core';

import { TenantDto } from '@picflow/types';
import { BrowserService } from 'src/app/services/browser.service';
import { PublicTenantService } from 'src/app/services/public-tenant.service';

@Injectable({
  providedIn: 'root',
})
export class TenantProfileResolve  {
  constructor(private publicTenantService: PublicTenantService, private browserService: BrowserService) {}

  async resolve() {
    const subDomain = this.browserService.getTenantSubDomain();
    const customDomain = this.browserService.getTenantCustomDomain();
    if (!subDomain && !customDomain) return;
    let tenant: TenantDto;

    if (customDomain) {
      tenant = await this.publicTenantService.getTenantFromCustomDomain(customDomain);
    } else {
      tenant = await this.publicTenantService.getTenant(subDomain);
    }
    return tenant;
  }
}
